"use client";

import { SquarePen } from "lucide-react";
import Link from "next/link";
import React from "react";
import useSWR from "swr";

import { ClientOnly } from "@/components/client-only";
import { buttonVariants } from "@/components/ui/button";
import { useUser } from "@/lib/hooks/auth";
import { swrFetcher } from "@/lib/hooks/fetch-client";
import { cn } from "@/lib/utils";

interface StaffEditButtonProps {
	text: string;
	slug: string;
	type: "study_summaries" | "supplement_guides";
}

export default function StaffEditButton({ text, slug, type }: StaffEditButtonProps) {
	const { user } = useUser();

	const { data: adminUrl } = useSWR(
		user?.is_staff ? [`/v1/study-summaries/link/${slug}`] : null,
		swrFetcher
	);

	if (!user?.is_staff || !adminUrl?.url) return null;

	return (
		<ClientOnly>
			<div className="-mb-2 flex w-full justify-around px-4 md:flex-col">
				<Link
					href={adminUrl?.url}
					target="_blank"
					className={cn(
						buttonVariants({ variant: "outline" }),
						"justify-center rounded-md border border-dashed border-primary  bg-info px-4 py-2 text-primary transition duration-200"
					)}
				>
					<SquarePen strokeWidth={1.2} size={20} />
					<span className="ml-1">{text}</span>
				</Link>
			</div>
		</ClientOnly>
	);
}
